import { render, staticRenderFns } from "./LastKPIList.vue?vue&type=template&id=ebf88eee&scoped=true&"
import script from "./LastKPIList.vue?vue&type=script&lang=js&"
export * from "./LastKPIList.vue?vue&type=script&lang=js&"
import style0 from "./LastKPIList.vue?vue&type=style&index=0&id=ebf88eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf88eee",
  null
  
)

export default component.exports